import { createTheme } from "@mui/material/styles";

const { palette } = createTheme();
const createColor = (mainColor) => { return palette.augmentColor({ color: { main: mainColor } }) };

const theme = createTheme({
  palette: {
    anger: createColor('#F40B27'),
    apple: createColor('#5DBA40'),
    steelBlue: createColor('#5C76B7'),
    violet: createColor('#BC00A3'),
    lime: createColor('#bfd447')
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: 16,
        },
        notchedOutline: {
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: 16,
        },
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: '1.5em',
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: 16,
        }
      }
    },
  }
});

export default theme;
